import React from "react";

interface ViewModeProps {
	onChange: React.ReactEventHandler<HTMLInputElement>;
	mode: string;
	value: string;
	id: string;
	label: string;
	disabled?: boolean;
	children?: React.ReactNode;
}

export function ViewMode({
	onChange,
	mode,
	value,
	id,
	label,
	disabled,
	children,
}: ViewModeProps) {
	const isSelected = mode === value;

	const body =
		isSelected && children ? (
			<div className="additional-fields">{children}</div>
		) : null;

	return (
		<fieldset>
			<div className="radio-input">
				<input
					type="radio"
					id={id}
					name="search-save-search"
					value={mode}
					checked={isSelected}
					onChange={onChange}
					disabled={disabled}
				/>
				<label htmlFor={id}>{label}</label>
			</div>
			{body}
		</fieldset>
	);
}
